import AuthService from "./AuthService";
import AuthApi from "./AuthApi";
import environment from "../../environment";
import BaseApi from "../BaseApi";

export default class AuthRUService extends AuthService {

    static login(command) {
        command.sistema = environment.sistema;
        return AuthApi.post(`/v1/authenticate/ru`, command).then(
            result => {
                const authorization = result.data.data;

                if (authorization.user.menus.length === 0) {
                    AuthRUService.gerarPermissao(Number.parseInt(command.ru));
                }

                if (authorization && authorization.token)
                    this._saveCredentials(authorization);

                return authorization.user.nome;
            }
        );
    }

    static gerarPermissao(ru) {
        BaseApi.post(`v1/permissao`, { ru }).then(
            result => {
                if (result === true) {
                    AuthRUService.refreshCredentials();
                }
            });
    }

    static async refreshCredentials() {
        AuthApi.get(`v1/authenticate/refreshcredentials/${environment.sistema}`).then(
            response => {
                if (response && response.data.token) {
                    this._saveCredentials(response.data);
                    return true;
                } else {
                    return false;
                }
            });
    }
}
